var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-popup',{staticStyle:{"background":"white"}},[_c('f7-page',{staticStyle:{"background":"white"}},[_c('f7-navbar',{attrs:{"back-link":""}},[_c('f7-nav-title',{staticClass:"comment-title"},[_vm._v("Comment for "+_vm._s(_vm.component))])],1),_c('div',[_c('h4',{staticClass:"comment"},[_vm._v(_vm._s(decodeURIComponent(_vm.comment)))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }